// extracted by mini-css-extract-plugin
export default {"recommend":"index_recommend_veMtH","title":"index_title_RpH8k","list_box":"index_list_box_AYlEW","more":"index_more_9rmsS"};